const showMailFeature = true;
const currentCountry = 'US';
const dataModel = {
  showCustomerManagedKeyFeature: true,
  showMailFeature,
  showMailFeatureSubtitle: showMailFeature && ['US', 'CA'].includes(currentCountry),
  billingConf: {
    isWhiteboardAddonDisabled: false,
  },
}

window.dataModel = dataModel;

export default dataModel;
